import { render, staticRenderFns } from "./CompanyMain.vue?vue&type=template&id=5e0ca4b4&scoped=true&"
import script from "./CompanyMain.vue?vue&type=script&lang=js&"
export * from "./CompanyMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0ca4b4",
  null
  
)

export default component.exports